import React, { useEffect, useState } from 'react'
import Button from '../button/Button';
import { BUTTON_TYPE } from '../button/constants';
import styles from './TextExpansion.styles';

export default function TextExpansion({ customStyle, defaultHeight = '100px', children }) {
	const [maxHeight, setMaxHeight] = useState(defaultHeight);
	const [showMore, setShowMore] = useState(true);

	useEffect(() => {
		setMaxHeight(showMore ? defaultHeight : 'none')
	}, [showMore])

	return (
		<div>
			<div style={{ maxHeight, ...styles.overflowHidden, ...customStyle }}>
				{children}
			</div>
			<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} style={styles.marginTop} onClickCb={() => setShowMore(prev => !prev)}>{showMore ? 'Show More' : 'Show Less'}</Button>
		</div>
	)
}